

















// eslint-disable-next-line @typescript-eslint/no-var-requires
const { version } = require('../package.json');
import { Component, Vue } from 'vue-property-decorator';
import DefaultLayout from './components/layouts/DefaultLayout.vue';
import { FileHandler } from './helpers/fileManager';
import { FirebaseRemoteConfig } from './main';
import { globalState } from './shared';

@Component({
  components: {
    DefaultLayout,
  },
})
export default class App extends Vue {
  centerDialogVisible = false;

  async beforeMount() {
    await FirebaseRemoteConfig.fetchAndActivate();
    if (FirebaseRemoteConfig.getString('newest_app_version') !== version) {
      this.centerDialogVisible = true;
    }
  }

  confirmUpdateClicked() {
    this.centerDialogVisible = false;
    window.open('https://markably.io#download', '_blank');
  }

  // TODO implement cmd-s save file
  async saveFileDialog(e: Event) {
    e.preventDefault();
    await FileHandler.saveFile(globalState.editorContentHtml);
    this.$message({ message: 'Saving', duration: 800, customClass: 'save-popop-message', type: 'success' });
  }

  copyEvent() {
    document.execCommand('copy');
  }

  pasteEvent() {
    document.execCommand('paste');
  }
}
